/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Wiki_Fieldstatus1Inputs */



/**

* @param {_Wiki_Fieldstatus1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _wiki_fieldstatus1 = /** @type {((inputs?: _Wiki_Fieldstatus1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Wiki_Fieldstatus1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Status")
});
export { _wiki_fieldstatus1 as "_wiki_fieldStatus" }